import base_config from "./base_config";

const prod_config = {
  ...base_config,
  STAGE: "prod",
  ACCOUNT: "966433002334",

  // Amplify config for cognito
  AMPLIFY_CONFIG: {
    aws_project_region: base_config.REGION,
    aws_cognito_region: base_config.REGION,
    aws_user_pools_id: "YOUR_PROD_USER_POOL_ID", // TODO: Update with prod user pool
    aws_user_pools_web_client_id: "YOUR_PROD_CLIENT_ID", // TODO: Update with prod client ID
    oauth: {
      domain: "YOUR_PROD_COGNITO_DOMAIN.auth.us-west-2.amazoncognito.com", // TODO: Get from Cognito console
      scope: base_config.TOKEN_SCOPES_ARRAY,
      redirectSignIn: base_config.CALL_BACK_URL,
      redirectSignOut: base_config.CALL_BACK_URL,
      responseType: base_config.OAUTH_RESPONSE_TYPE,
    },
  },

  // API Gateway Base URL
  BASE_URL: "YOUR_PROD_API_GATEWAY_URL", // TODO: Update with prod API Gateway URL
};

export default prod_config;
